import { useEffect, useState } from "react"
import { Granularity } from "@hydrologiq/common/types/reporting/Granularity"
import { nowDateTime, toUserTZ } from "@hydrologiq/common/helpers/date"
import { DateTime } from "timezonecomplete"
import Informative from "@hydrologiq/shared/Informative"
import CustomerUsage, { CustomerUsageSkeleton } from "@hydrologiq/customers/components/usage/CustomerUsage"
import * as gqlTypes from "@hydrologiq/gql/graphql"
import { useLazyQuery } from "@apollo/client"
import { Customer } from "@hydrologiq/gql-experience/graphql"

function UsageInline({ customer }: { customer?: Customer | undefined }) {
  const customerName = customer?.name
  const [start, setStart] = useState<DateTime>()
  const [end, setEnd] = useState<DateTime>()

  const [granularity] = useState<Granularity>(Granularity.Daily)
  const [getAssignmentsSummary, { loading, error }] = useLazyQuery(gqlTypes.GetAssignmentsSummaryDocument)

  useEffect(() => {
    setStart(undefined)
    setEnd(undefined)
    if (customer) {
      getAssignmentsSummary({ variables: { customer: customer.id } }).then((data) => {
        if (data.data) {
          setStart(data.data?.summary.start ? toUserTZ(data.data.summary.start) : undefined)
          setEnd(data.data?.summary.end ? toUserTZ(data.data.summary.end) : nowDateTime())
        }
      })
    }
  }, [customer])

  return error || (!loading && !start) ? (
    <Informative
      heading="Waiting for data to be available"
      text="Usage information will be available when an asset has been utilised."
    />
  ) : (
    <>
      {loading || !customer || !customerName || !end || !start ? (
        <CustomerUsageSkeleton view={"chart"} title={false} />
      ) : (
        <CustomerUsage
          title={false}
          customerId={customer.id}
          end={end}
          start={start}
          granularity={granularity}
          customerName={customerName}
          view={"chart"}
          latest={true}
        />
      )}
    </>
  )
}

export default UsageInline
